<template>
  <v-container fill-height>
    <v-layout align-center>
      <v-flex text-center>
        <img style="margin-top: 5px; width: 100px; height: 100px;" src="../assets/Negado.png" />
        <h1 class="display-2 error--text">Erro 401!</h1>
        <p>Você não tem autorização para acessar essa página!</p>
        <v-btn @click="redirect" outlined color="primary">
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    redirect() {
      this.$router.back();
    }
  }
};
</script>